/**
* 订单管理 交易订单
*/
<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>供应商订单</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索筛选 -->
    <el-form :inline="true" :model="formInline" class="user-search">
      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
      </el-form-item>
    </el-form>
    <!--列表-->
    <el-table size="small" :data="listData" highlight-current-row v-loading="loading" border
      element-loading-text="拼命加载中" style="width: 100%;">
      <el-table-column prop="orderNo" label="id" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="supplierName" label="渠道名称" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="orderOriginAmount" label="订单金额(含运费)" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="userOriginAmount" label="实付金额(含运费)" show-overflow-tooltip>
      </el-table-column>
      
      <el-table-column align="center" label="操作">
        <template slot-scope="scope">
          <el-button size="mini" @click="handleEdit(scope.$index, scope.row.supplierOrderNo)">查看详情</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页组件 -->
    <!-- <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination> -->
    <!-- 编辑界面 -->

  </div>
</template>

<script>
  import {
    b2cordersupplierOrder
  } from '../../api/userMG'
  import Pagination from '../../components/Pagination'
  export default {
    data() {
      return {
        loading: false, //是显示加载
        editFormVisible: false, //控制编辑页面显示与隐藏
        title: '预览',
        editForm: {
          id: '',
          name: '',
          payType: 1,
          partner: '',
          subMchId: '',
          appid: '',
          notifyUrl: '',
          signType: '',
          partnerKey: '',
          sellerUserId: '',
          certPath: '',
          certPassword: '',
          rsaKey: '',
          token: sessionStorage.getItem('logintoken')
        },
        formInline: {
          page: 1,
          limit: 20,
          payerUserid: '',
          orderNo: this.$route.query.orderNo,
          orderId: '',
          value1: '',
          type: '-1'
        },
        optionsorderState: '',
        // 删除部门
        seletedata: {
          ids: '',
          token: sessionStorage.getItem('logintoken')
        },
        options: [],
        userparm: [], //搜索权限
        listData: [], //用户数据
        // 分页参数
        pageparm: {
          currentPage: 1,
          pageSize: 20,
          total: 10
        }
      }
    },
    // 注册组件
    components: {
      Pagination
    },
    /**
     * 数据发生改变
     */

    /**
     * 创建完毕
     */
    created() {
      this.getdata(this.formInline)
    },

    /**
     * 里面的方法只有被调用才会执行
     */
    methods: {
      // 获取公司列表
      getdata(parameter) {
        let pro = {
          "userId": "abcdef",
          "orderNo": parameter.orderNo,
        }
        b2cordersupplierOrder(pro)
          .then(res => {
            this.loading = false
            if (res.code == 200) {
              this.listData = res.data
            } else {
              this.$message({
                type: 'info',
                message: res.msg
              })
            }
          })

      },
      // 分页插件事件
      callFather(parm) {
        this.formInline.page = parm.currentPage
        this.formInline.limit = parm.pageSize
        this.getdata(this.formInline)
      },
      // 搜索事件
      search() {
        this.formInline.page = 1
        this.getdata(this.formInline)
      },
      handleEdit(index, id) {
        this.$router.push({
          name: 'b2cproduct2',
          query: {
            supplierOrderNo: id
          }
        })
      }
    }
  }
</script>

<style scoped>
  .user-search {
    margin-top: 20px;
  }

  .userRole {
    width: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/views/b2c/product1.vue